@if (isShowDimensionsBlock || product.specification) {
  <div class="product-description">
    @if (product?.description) {
      <div class="product-description__text-wrapper">
        <div
          class="product-description__text"
          [class.is-truncate]="!isShowMore"
          [innerHTML]="product.description"
          translate
          #descriptionRef
        ></div>
        @if (isShowMoreButtonVisible) {
          <div class="product-description__read-more" (click)="toggleShowMore()">
            {{ !isShowMore ? 'Read more' : 'Read less' }}
          </div>
        }
      </div>
    }
    <div class="product-description-info">
      @if (product.specification) {
        <div
          class="product-description__specification"
          [class.is-border]="isShowDimensionsBlock"
        >
          <div
            class="product-description__specification-header"
            (click)="toggleProperty('isSpecificationCollapsed')"
            [ngClass]="{
              'product-description__specification-header--show': isSpecificationCollapsed,
            }"
          >
            <h3 class="product-description__specification-title" translate>
              Specification
            </h3>
          </div>
          @if (isSpecificationCollapsed) {
            <div class="specification-table" [innerHTML]="product.specification"></div>
          }
        </div>
      }
      @if (isShowDimensionsBlock) {
        <div class="product-description__dimensions">
          <div
            class="product-description__dimensions-header"
            (click)="toggleProperty('isDimensionsCollapsed')"
            [ngClass]="{
              'product-description__dimensions-header--show': isDimensionsCollapsed,
            }"
          >
            <h3 class="product-description__dimensions-title" translate>Dimensions</h3>
          </div>
          @if (isDimensionsCollapsed) {
            <ul class="product-description__dimensions-list list">
              @if (product.width) {
                <li class="item">
                  <span class="label" translate>{{ dimensionsLabels.width }}</span
                  ><span class="value">{{ product.width }}</span>
                </li>
              }
              @if (product.height) {
                <li class="item">
                  <span class="label" translate>{{ dimensionsLabels.height }}</span
                  ><span class="value"> {{ product.height }} </span>
                </li>
              }
              @if (product.length) {
                <li class="item">
                  <span class="label" translate>{{ dimensionsLabels.length }}</span
                  ><span class="value">{{ product.length }}</span>
                </li>
              }
              @if (product.depth) {
                <li class="item">
                  <span class="label" translate>{{ dimensionsLabels.depth }}</span
                  ><span class="value">{{ product.depth }}</span>
                </li>
              }
              @if (product.weight) {
                <li class="item">
                  <span class="label" translate>{{ dimensionsLabels.weight }}</span
                  ><span class="value">{{ product.weight }}</span>
                </li>
              }
              @if (product.parcel_s) {
                <li class="item">
                  <span class="label" translate>{{ dimensionsLabels.parcel_s }}</span
                  ><span class="value">{{ product.parcel_s }}</span>
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
  </div>
}
